import { FC } from 'react';

import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

import { cn } from 'utils/global';

import Button from './Button';

export interface Props {
  onClick?: VoidFunction;
  label?: string;
  className?: string;
}
const BackButton: FC<Props> = ({ onClick, label = 'Back', className }) => {
  const { t } = useTranslation();

  return (
    <Button
      leftIcon={faArrowLeft}
      className={cn('text-start text-primary-500 !bg-transparent mb-4', className)}
      onClick={onClick}
    >
      {t(label)}
    </Button>
  );
};

export default BackButton;
